"use client";

import { ThemeToggle } from "@vllnt/ui";
import { useTranslations } from "next-intl";

export function ThemeToggleClient() {
  const t = useTranslations();

  const themeDict = {
    theme: {
      dark: t("theme.dark"),
      light: t("theme.light"),
      system: t("theme.system"),
      toggle_theme: t("theme.toggle_theme"),
    },
  };

  return <ThemeToggle dict={themeDict} />;
}
